import React from "react";
import MenuBarReports from "./menuBarReports";


function HomeReports() {
  return (
    <>
   
    <MenuBarReports/>
    
    </>
  );
}
export default HomeReports;